import { render, staticRenderFns } from "./socket_notifications.vue?vue&type=template&id=22be6554&scoped=true&"
import script from "./socket_notifications.vue?vue&type=script&lang=js&"
export * from "./socket_notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22be6554",
  null
  
)

export default component.exports